<template>
  <div>
    <p class="p1">
      <slot name="description" />
    </p>
    <button class="button button_black _mt-32" type="button" @click="listeners['close']()">
      <slot name="buttonClose" />
    </button>
  </div>
</template>
<script>
export default {
  name: 'Confirm',
  emits: ['close', 'confirm'],
};
</script>
